<div class="row">
  <div class="col-12 overflow-hidden">
    <div class="card">
      <div class="card-header">
        <div>
          <h3>{{'lang.user.profilePictureUpload' | translate}}</h3>
        </div>
        <div class="header-more">

        </div>
      </div>

      <div class="card-fit">
        <div class="card-img fill border-bottom" style="height: 17rem">
          <div class="w-100 h-100 d-flex align-items-center justify-content-center">
            <div class="w-100 h-100 d-flex align-items-center justify-content-center" id="dropzone"
                 (drop)="dropHandler($event)" (dragover)="dragOverHandler($event)"
                 (dragenter)="isDragOver = true" (dragleave)="isDragOver = false"
                 [ngClass]="getDragAndDropClasses()">
              <h5>{{'lang.user.dragDropProfilePicture' | translate}}</h5>
            </div>
          </div>
        </div>
        <div class="p-4 d-flex justify-content-center align-items-center flex-column">
          <h5>{{'lang.globals.or' | translate}}</h5>
          <button (click)="openFilePicker()"
                  class="btn btn-primary ">{{'lang.mediumExplorer.uploadFiles' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<input #filePicker type="file" style="display:none;" (change)="filePicked()" multiple>
